<template>
  <div
    :class="classes(
      n(),
      n(`--${size}`),
      [disabled, n('--disabled')],
      [!!contentValue, n('--active')],
    )"
    :aria-checked="contentValue"
    :aria-disabled="disabled"
    @click="handleClick"
  >
    <div
      :class="classes(
        n(`--content`),
      )"
    >
      <div
        :class="classes(
          n('--dot')
        )"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'virtual-vue';
import { createNamespace } from '../utils/components';
import { props } from './props';
import { EmitEvents } from './emits';
import { useVModel } from '../hooks/use-v-model';
import { createEmits } from '../utils/emits';

/** emit相关声明 */
const { defineEmitType, useEmits } = createEmits<EmitEvents>();
const emits = defineEmitType(['change', 'input', 'update:modelValue']);

/** 组件名 + css类型生成 */
const { name, n, classes } = createNamespace('switch');

export default defineComponent({
  name,
  props,
  emits,
  setup(props) {
    const emit = useEmits();
    const contentValue = useVModel<boolean>(props);
    return {
      contentValue,
      handleClick: () => {
        const curValue = contentValue.value;
        if (props.disabled) {
          return;
        }
        contentValue.value = !curValue;
        emit('change', !curValue);
      },
      classes,
      n,
    };
  },
});
</script>
